// extracted by mini-css-extract-plugin
export default {"root":"fullscreenvideo_root__1Aa2Z","btn":"fullscreenvideo_btn__ifOv+"};